import React from "react";

export default function ArrowSvg({
                                     width = 10,
                                     height = 6,
                                     rotate = 0,
                                     color = "#282828",
                                 }) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: `rotate(${rotate}deg)` }}
        >
            <path
                d="M1.0293 5L4.99991 0.97083L9.02908 4.94145"
                stroke={color}
            />
        </svg>
    );
}